module.exports = __webpack_public_path__ + "static/media/privacy_trust-entrepreneurs-network.ac62bc21.svg";